import { PassengerStatus } from "./WebApiModels";

export const statusLabels = {
    [PassengerStatus.NotSent]: 'Irreg created (PNRs not sent)',
    [PassengerStatus.ManualActionsRequired]: 'Pending Submission (Manual Correction Required)',
    [PassengerStatus.Sent]: 'Submitted to Amadeus',
    [PassengerStatus.InProgress]: 'In Progress - PNR is being sent to Amadeus',
    [PassengerStatus.FailedToProcess]: 'PAX Not Successfully Created in Amadeus',
    [PassengerStatus.FailedToSend]: 'PAX Not Successfully Created in Amadeus',
    [PassengerStatus.Success]: 'PAX Successfully Created in Amadeus',
    [PassengerStatus.Rebooked]: 'PAX Rebooked',
    [PassengerStatus.RebookedFlown]: 'PAX Rebooked and Flown',
    [PassengerStatus.RebookedNotFlown]: 'PAX Rebooked and Not Flown',
    [PassengerStatus.RebookingNotNeeded]: 'PAX Rebooking not needed',
    [PassengerStatus.PaxVoided]: 'PAX voided',
    [PassengerStatus.NotRelevant]: 'Not relevant for Passenger Reprotection Process'
};

export const statusColors = {
    [PassengerStatus.NotSent]: '#ffff84',
    [PassengerStatus.ManualActionsRequired]: '#ebeb00',
    [PassengerStatus.Sent]: '#ffaa00',
    [PassengerStatus.InProgress]: '#ffd684',
    [PassengerStatus.FailedToProcess]: '#dc3545',
    [PassengerStatus.FailedToSend]: '#dc3545',
    [PassengerStatus.Success]: '#56dd9e',
    [PassengerStatus.Rebooked]: '#198754',
    [PassengerStatus.RebookedFlown]: '#1a5dc9',
    [PassengerStatus.RebookedNotFlown]: '#5a92ed',
    [PassengerStatus.RebookingNotNeeded]: '#198754',
    [PassengerStatus.PaxVoided]: '#198754',
    [PassengerStatus.NotRelevant]: '#6c757d',
};

export const completeStatuses = [PassengerStatus.Rebooked, PassengerStatus.RebookingNotNeeded, PassengerStatus.PaxVoided, PassengerStatus.NotRelevant];

export type RefreshRoomPayload = {
    flightIds: string[];
};